export default __webpack_public_path__ + "static/media/pancreas_plot_male.8f88458b.png";